import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Form } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ServiceTemplateForm } from "./serviceTemplateForm.js";
import { useFormValidation } from "../../../../../hooks/form/useFormValidation.js";
import { useServiceTemplateCreate } from "../../../../../hooks/service/useServiceTemplateCreate.js";
import { useTranslation } from "../../../../../others/i18n.js";
import { useStores } from "../../../../../store/root.js";
function ServiceTemplateCreate() {
    const { t } = useTranslation();
    const { notificationStore } = useStores();
    const navigate = useNavigate();
    const [serviceTemplateToCreate, setServiceTemplateToCreate] = useState();
    const [isSubmitting, setSubmitting] = useState(false);
    const [templateForm] = Form.useForm();
    const [validationErrors, setValidationErrors] = useState(undefined);
    useFormValidation(templateForm, validationErrors);
    const useCreateServiceTemplate = useServiceTemplateCreate(serviceTemplateToCreate);
    useEffect(()=>{
        const { data, error, isError, isSuccess } = useCreateServiceTemplate;
        if (isSuccess && data && !isNaN(Number(data.id))) {
            notificationStore.clearAll();
            setValidationErrors(undefined);
            const search = new URLSearchParams({
                headline: data.headline
            }).toString();
            navigate({
                pathname: "/rcb/service",
                search: `?${search}`
            });
        } else if (isError && error) {
            notificationStore.clearAll();
            setValidationErrors(error);
            notificationStore.addFromServerError(error, t);
        }
    }, [
        useCreateServiceTemplate,
        serviceTemplateToCreate
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Breadcrumb, {
                items: [
                    {
                        href: "/rcb",
                        title: /*#__PURE__*/ _jsx(HomeOutlined, {})
                    },
                    {
                        href: "/rcb/service",
                        title: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(UserOutlined, {}),
                                /*#__PURE__*/ _jsx("span", {
                                    children: t("Services")
                                })
                            ]
                        })
                    },
                    {
                        title: t("Create")
                    }
                ]
            }),
            /*#__PURE__*/ _jsx(ServiceTemplateForm, {
                isSubmitting: isSubmitting,
                isLoading: useCreateServiceTemplate.isFetching,
                serviceTemplate: undefined,
                templateForm: templateForm,
                onSubmit: (template)=>{
                    template["_lastSubmit"] = new Date().getTime();
                    setSubmitting(true);
                    setServiceTemplateToCreate(template);
                }
            })
        ]
    });
}
export { ServiceTemplateCreate };
